import { AxiosPromise } from "axios";
import { apiWrapper } from "../../axiosInstance";
import { FeatureLayersMappingServiceResponse } from "./featureLayersMapping.service";

export const featureLayersMappingEndpoint = (): AxiosPromise<FeatureLayersMappingServiceResponse> =>
    apiWrapper.instance!.get(`rest/sdo/featureShortNameToLayersMapping`);
